export default [
    {
        path: '/ambiences/schedule-activities',
        name: 'ambiences-schedule-activities',
        component: () => import ('./views/ScheduleActivityIndex'),
        meta: {
            title: 'Atividade Agendada',
            icon: 'mdi-calendar-check',
            breadcrumbs: [
                { text: 'Totvs - Salas', disabled: true },
                { text: 'Atividade Agendada', disabled: true }
            ]
        }
    },
]
